module.exports = __webpack_public_path__ + "static/media/arrow-left-disabled.cc466a1a.svg";